import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface VideoStyleMeta {
  name: string;
  tagline: string;
  description: string;
  suitableFor: string[];
}

export function useVideoStyles() {
  return useQuery<VideoStyleMeta[]>({
    queryKey: ['video-styles'],
    queryFn: () => api.get('styles').json<VideoStyleMeta[]>(),
    staleTime: Infinity,
  });
}
